import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import MessageModal from '../components/modals/message-modal';
import FarmAlreadyExistsModal from '../components/modals/external/farm-already-exists-modal';
import UserAlreadyExistsModal from '../components/modals/external/user-already-exists-modal';
import LatviaLvAuthenticationFailModal from '../components/modals/external/latvia-lv-authentication-fail-modal';
import UserVerificationFailModal from '../components/modals/external/user-verification-fail-modal';
import ForgotPasswordSuccessModal from '../components/modals/external/forgot-password-success-modal';

export function useMessageModal() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const { replace } = useHistory();
  const [messageModal, setMessageModal] = useState(null);
  const close = useCallback(() => setMessageModal(null), []);

  useEffect(() => {
    const query = new URLSearchParams(search);

    if (query.has('message')) {
      const message = query.get('message');
      switch (message) {
        case 'farm_already_exists':
          setMessageModal(<FarmAlreadyExistsModal onClose={close} />);
          break;
        case 'user_already_exists':
          setMessageModal(<UserAlreadyExistsModal onClose={close} />);
          break;
        case 'failed_to_authenticate_with_latvija_lv':
          setMessageModal(<LatviaLvAuthenticationFailModal onClose={close} />);
          break;
        case 'failed_to_verify_user':
          setMessageModal(<UserVerificationFailModal onClose={close} />);
          break;
        case 'forgot_password_success':
          setMessageModal(<ForgotPasswordSuccessModal onClose={close} />);
          break;
        default:
          setMessageModal(
            <MessageModal
              message={t(message)}
              onClose={() => setMessageModal(null)}
            />
          );
      }

      query.delete('message');
      replace({ search: query.toString() });
    }
  }, [search, replace, t, close]);

  return messageModal;
}
